import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { FC } from 'react'
import { SeverityIcon } from '../severityIcon'

type SeverityProps = {
    severity: Exclude<TIssueSeverity, 'clean'>
    description: string
}

export const Severity: FC<SeverityProps> = ({ severity, description }) => {
    return (
        <View style={styles.container}>
            <SeverityIcon severity={severity} />
            <View>
                <Text style={styles.severity}>{severity}</Text>
                <Text style={styles.description}>{description}</Text>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: 10,
        marginBottom: 12,
    },
    severity: {
        fontWeight: 'bold',
        textTransform: 'capitalize',
    },
    description: {
        maxWidth: 105,
    },
})
